export const eppExpLanguageDef: monaco.languages.IMonarchLanguage = {
  tokenizer: {
    root: [
      [/[a-zA-Z_$][\w$]*/,                  'epp-default'],
      [/[\[\]\{\}\(\)]/,                    'epp-brackets'],
      [/[+\-*/]/,                           'epp-number-operator'],
      [/[><=]/,                             'epp-logic-operator'],
      [/sys.[a-zA-Z_$][\w$]*/,              'epp-sys-var'],
      [/[a-zA-Z_$][\w$]*(?=\(\))/,          'epp-function'],
      [/\d+/,                               'epp-number'],
    ]
  }
}
